module.exports = __webpack_public_path__ + "static/VikasGoel-127ef55f0c29fbfb4aace27c28e8cabe.jpg";